// File: src/pages/UserSettingsPage.js
// This page is updated with a new field for setting a custom water goal.
import React from 'react';
import { Link } from 'react-router-dom';

function UserSettingsPage({ userSettings, setUserSettings }) {

  const handleUnitChange = (e) => {
    const newUnitSystem = e.target.value;
    const currentGoal = userSettings.waterGoal;
    // When switching units, convert the goal to the nearest common value
    const newWaterGoal = newUnitSystem === 'metric' 
      ? (currentGoal < 34 ? Math.round(currentGoal * 29.5735 / 250) * 250 : currentGoal) // oz to ml
      : (currentGoal > 100 ? Math.round(currentGoal / 29.5735 / 8) * 8 : currentGoal); // ml to oz
    setUserSettings({ ...userSettings, unitSystem: newUnitSystem, waterGoal: newWaterGoal });
  };

  const handleWaterGoalChange = (e) => {
    setUserSettings({ ...userSettings, waterGoal: parseInt(e.target.value) || 0 });
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <header className="bg-black shadow-md">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <img src="/Logo.png" alt="R.A.W. Fitness Logo" className="h-12 w-auto" />
            <h1 className="text-xl font-bold text-lime">My Settings</h1>
          </div>
          <nav>
            <Link to="/dashboard" className="text-white hover:text-lime transition duration-300">Back to Dashboard</Link>
          </nav>
        </div>
      </header>
      <main className="container mx-auto px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="md:col-span-2 space-y-8">
                <div className="bg-gray-800 p-8 rounded-lg shadow-lg">
                    <h2 className="text-3xl font-bold mb-6 text-magenta">Profile Information</h2>
                    {/* Placeholder for profile form */}
                    <p className="text-gray-400">Forms to update name, email, etc. will go here.</p>
                </div>
                 <div className="bg-gray-800 p-8 rounded-lg shadow-lg">
                    <h2 className="text-3xl font-bold mb-6 text-magenta">Change Password</h2>
                    {/* Placeholder for password form */}
                    <p className="text-gray-400">A form to change the user's password will go here.</p>
                </div>
            </div>
            <div className="space-y-8">
                <div className="bg-gray-800 p-8 rounded-lg shadow-lg">
                    <h2 className="text-3xl font-bold mb-6 text-lime">Preferences</h2>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-gray-400 text-sm font-bold mb-2">Unit System</label>
                            <div className="flex items-center space-x-4">
                                <label className="flex items-center">
                                    <input type="radio" name="unit" value="metric" checked={userSettings.unitSystem === 'metric'} onChange={handleUnitChange} className="form-radio h-5 w-5 text-magenta bg-gray-700 border-gray-600 focus:ring-magenta" />
                                    <span className="ml-2">Metric (kg, cm)</span>
                                </label>
                                 <label className="flex items-center">
                                    <input type="radio" name="unit" value="us" checked={userSettings.unitSystem === 'us'} onChange={handleUnitChange} className="form-radio h-5 w-5 text-magenta bg-gray-700 border-gray-600 focus:ring-magenta" />
                                    <span className="ml-2">US (lbs, in)</span>
                                </label>
                            </div>
                        </div>
                        <div>
                            <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="waterGoal">Daily Water Goal ({userSettings.unitSystem === 'metric' ? 'ml' : 'oz'})</label>
                            <input id="waterGoal" type="number" value={userSettings.waterGoal} onChange={handleWaterGoalChange} className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-600 focus:border-lime" />
                        </div>
                    </div>
                </div>
                 <div className="bg-gray-800 p-8 rounded-lg shadow-lg">
                    <h2 className="text-3xl font-bold mb-6 text-lime">Notifications</h2>
                    {/* Placeholder for notification settings */}
                    <p className="text-gray-400">Toggles for email and in-app notifications will go here.</p>
                </div>
            </div>
        </div>
        <div className="mt-8 text-right">
            <button className="bg-magenta text-black font-bold py-3 px-6 rounded-lg hover:bg-opacity-80 transition duration-300 glow-magenta" type="button">
                Save All Settings
            </button>
        </div>
      </main>
    </div>
  );
}

export default UserSettingsPage;

